import BaseFilter from './BaseFilter';
import { requestGetStates as request } from '../../../state/ducks/filters/api';

const StateFilter = ({ value, onChange }) =>
  BaseFilter({
    value,
    onChange,
    request,
    labelSelector: (state) => state.name,
    valueSelector: (state) => state.abbreviation,
    preloadOptions: true,
  });

StateFilter.defaultProps = BaseFilter.defaultProps;

export default StateFilter;
